import { Directive, HostListener, Input } from '@angular/core';

declare var gtag;

@Directive({
  selector: '[eventTracker]'
})
export class AnalyticsDirective {

	@Input('eventTracker') option:any;

	@HostListener('click', ['$event']) onClick($event){
		// Params: action, category, label
		var params = {
		  'event_category' : this.option.category,
		  'event_label' : this.option.label,
		  'event_callback': function() {
		  }
		}

		gtag('event', this.option.action, params);
	  }

  	constructor() { }

}
